import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
    apiListBankAccounts,
    apiListBrands,
    apiListCategories,
    apiListCustomers,
    apiListExpenses,
    apiListOrders,
    apiListProducts,
    apiListPurchases,
    apiListReferrals,
    apiListRoles,
    apiListVendors,
} from 'Services/StoreUserService'

export const getRoles = createAsyncThunk('storeUser/list/getRoles', async () => {
    const { data } = await apiListRoles()
    return data
})

export const getBankAccounts = createAsyncThunk('storeUser/list/getBankAccounts', async () => {
    const { data } = await apiListBankAccounts()
    return data
})

export const getBrands = createAsyncThunk('storeUser/list/getBrands', async () => {
    const { data } = await apiListBrands()
    return data
})

export const getCategories = createAsyncThunk('storeUser/list/getCategories', async id => {
    const { data } = await apiListCategories(id)
    return data
})

export const getExpenses = createAsyncThunk('storeUser/list/getExpenses', async () => {
    const { data } = await apiListExpenses()
    return data
})

export const getCustomers = createAsyncThunk('storeUser/list/getCustomers', async id => {
    const { data } = await apiListCustomers(id)
    return data
})

export const getVendors = createAsyncThunk('storeUser/list/getVendors', async () => {
    const { data } = await apiListVendors()
    return data
})

export const getReferrals = createAsyncThunk('storeUser/list/getReferrals', async () => {
    const { data } = await apiListReferrals()
    return data
})

export const getProducts = createAsyncThunk('storeUser/list/getProducts', async id => {
    const { data } = await apiListProducts(id)
    return data
})

export const getPurchases = createAsyncThunk('storeUser/list/getPurchases', async id => {
    if (!id) return []
    const { data } = await apiListPurchases(id)
    return data
})

export const getOrders = createAsyncThunk('storeUser/list/getOrders', async id => {
    const { data } = await apiListOrders(id)
    return data
})

export const listSlice = createSlice({
    name: 'storeUser/list',
    initialState: {
        loading: true,
        roles: [],
        bankAccounts: [],
        brands: [],
        categories: [],
        expenses: [],
        customers: [],
        vendors: [],
        referrals: [],
        products: [],
        purchases: [],
        storeOrders: [],
        orders: [],
    },
    extraReducers: builder => {
        builder
            .addCase(getRoles.fulfilled, (state, { payload }) => {
                state.roles = payload
            })
            .addCase(getRoles.rejected, state => {
                state.roles = []
            })
            .addCase(getBankAccounts.fulfilled, (state, { payload }) => {
                state.bankAccounts = payload
            })
            .addCase(getBankAccounts.rejected, state => {
                state.bankAccounts = []
            })
            .addCase(getBrands.fulfilled, (state, { payload }) => {
                state.brands = payload
                state.categories = []
            })
            .addCase(getBrands.rejected, state => {
                state.brands = []
                state.categories = []
            })
            .addCase(getCategories.fulfilled, (state, { payload }) => {
                state.categories = payload
            })
            .addCase(getCategories.rejected, state => {
                state.categories = []
            })
            .addCase(getExpenses.fulfilled, (state, { payload }) => {
                state.expenses = payload
            })
            .addCase(getExpenses.rejected, state => {
                state.expenses = []
            })
            .addCase(getCustomers.fulfilled, (state, { payload }) => {
                state.customers = payload
            })
            .addCase(getCustomers.rejected, state => {
                state.customers = []
            })
            .addCase(getVendors.fulfilled, (state, { payload }) => {
                state.vendors = payload
            })
            .addCase(getVendors.rejected, state => {
                state.vendors = []
            })
            .addCase(getReferrals.fulfilled, (state, { payload }) => {
                state.referrals = payload
            })
            .addCase(getReferrals.rejected, state => {
                state.referrals = []
            })
            .addCase(getProducts.fulfilled, (state, { payload }) => {
                state.products = payload
            })
            .addCase(getProducts.rejected, state => {
                state.products = []
            })
            .addCase(getPurchases.fulfilled, (state, { payload }) => {
                state.purchases = payload
                state.orders = []
            })
            .addCase(getPurchases.rejected, state => {
                state.purchases = []
                state.orders = []
            })
            .addCase(getOrders.fulfilled, (state, { payload }) => {
                state.purchases = []
                state.orders = payload
            })
            .addCase(getOrders.rejected, state => {
                state.purchases = []
                state.orders = []
            })
    },
})

export default listSlice.reducer
